import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  children?: React.ReactNode;
  readonly onClick?: any;
}

export const CategorySubmenuList = styled.div<IProps>`
  position: relative;
  background-color: #f6f6f6;
  border-bottom: 1px solid #eee;
  ${mixin.flex({
    justify: 'flex-start',
    align: 'stretch',
  })};

  .list {
    width: 118px;
  }

  .area-sub {
    width: calc(100% - 118px);
    background-color: #fff;
    padding: 12px 20px 20px 16px;

    .sub-list {
      ${mixin.flex({
        justify: 'flex-start',
        align: 'flex-start',
        wrap: 'wrap',
      })};
      gap: 0 13px;

      .item {
        width: calc(50% - 6.5px);
      }

      .btn {
        font-weight: 400;
        line-height: 130%;
        height: auto;
        padding: 8px 0;
        color: #000;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .list {
      width: ${mixin.pxToVw('118')};
    }

    .area-sub {
      width: calc(100% - ${mixin.pxToVw('118')});
      padding: ${mixin.pxToVw('10 20 20 20 ')};

      .sub-list {
        gap: ${mixin.pxToVw('0 13')};

        .item {
          width: calc(50% - ${mixin.pxToVw('6.5')});
        }

        .btn {
          padding: ${mixin.pxToVw('8 0')};
        }
      }
    }
  }
`;
